// extracted by mini-css-extract-plugin
export var brand = "_2x-8";
export var compact = "_2x-5";
export var extraSmall = "_2x-6";
export var icon = "_2x-0";
export var large = "_2x-3";
export var light = "_2x-1";
export var medium = "_2x-4";
export var outline = "_2x-a";
export var primaryDark = "_2x-9";
export var primaryLight = "_2x-7";
export var primaryModern = "_2x-b";
export var success = "_2x-2";